import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <div className="about">
      <div className="letter-container">
        <div className="letter-paper">
          <div className="letter-header">
            <div className="letterhead">
              <h3>EcoFashion</h3>
              <p>Athens, Greece</p>
            </div>
          </div>
          
          <div className="letter-body">
            <h1 className="letter-title">About Eco Fashion</h1>
            
            <p className="letter-paragraph">
              Eco Fashion started during the quarantine years, a way for me to create something meaningful in a time that felt repetitive and dull. But it also came from frustration: with fast fashion, with monotony, with everyone wearing the same things.
            </p>
            
            <p className="letter-paragraph">
              That's when I fell in love with vintage, for its uniqueness, its value, and the eras it carries! I focus on authentic vintage, deadstock gems, and reworked pieces, all selected or made by hand.
            </p>
            
            <p className="letter-paragraph">
              My style is guided by instinct and nostalgia. I believe that styling has the power to transform anything, and that fashion doesn't need rules, just feeling.
            </p>
            
            <p className="letter-paragraph">
              To me, eco is a mindset. It's about conscious consumerism, choosing vintage, reimagining old things, and supporting slow fashion over mass production.
            </p>
            
            <p className="letter-paragraph">
              The space reflects that philosophy - part showroom, part archive, part open studio. A place to explore freely, get inspired, and see the process behind the pieces.
            </p>
            
            <p className="letter-paragraph">
              Every item is handpicked, styled, or redesigned with intention, turning passion for fashion and sustainability into a living, evolving archive.
            </p>
            
            <p className="letter-paragraph">
              No gatekeeping, just real work and honest creativity.
            </p>
            
            <div className="letter-signature">
              <p className="closing">Xoxo,</p>
              <div className="signature-line">
                <span className="handwritten-signature">Cassie ♡</span>
              </div>
              <p className="title">Founder of Eco Fashion Living</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;